import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {Product} from "../Models/product";
import {ProductConfiguration} from "../Models/product-configuration";

@Injectable({
  providedIn: 'root'
})
export class WissalstoreService {


  sideNavOpen = false;
  showNavMenu = false;
  showFilter = false;

  //----catalog ---
  selectedCategoryId = 0;
  searchedPorducts: ProductConfiguration[] = [];
  //--------


  //-------
  defaultAddress = 1;
  //-------


  constructor() { }

}
